import { useEffect } from 'react';
import { useNewBookingStore } from '../../../../domain/booking/stores/useNewBookingsStore';

/**
 * If any Parking Product was previously selected, make sure it is reset, and the original Parking Product selection is used
 */
export function useResetParkingProductUpgradeWhenMounted() {
	const store = useNewBookingStore();

	useEffect(() => {
		store.removeUpgrade();
	}, []);
}
